import React, { useEffect, useState } from "react";
import SimpleBarFilterCustom from "../../../components/Common/SimpleBarFilterCustom";
import {
  Button,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
} from "reactstrap";
import ProgressBar from "../../../components/Common/ProgressBar";
import InputSearch from "../../../components/Inputs/InputSearch";
import HeaderDefaultToPage from "../../../components/Common/headerDefaultToPage";
import PreFilterBadge from "../../../components/Common/PreFilterBadge";
import {
  exportGridToExcel,
  exportGridToCSV,
  exportGridToHTML,
} from "../../../components/Utils/export";
import TranspaleStringToComponente from "../../../components/Dynamic/TranspaleStringToComponente";
import { useSelector } from "react-redux";

const EXPORT_COLUMNS = [
  { field: "Status", header: "Status", width: "5%", hasImage: true, Export: true },
  { field: "ID_Tabela_Frete", header: "ID", Export: true },
  { field: "Transportadora", header: "Transportadora", hasImage: true, Export: true },
  { field: "Fornecedor", header: "Fornecedor", hasImage: true, Export: true },
  { field: "Municipio_Origem", header: "Origem", Export: true },
  { field: "UF_Origem", header: "UF Origem", Export: true },
  { field: "Destino", header: "Destino", hasImage: true, Export: true },
  { field: "UF_Destino", header: "UF Destino", Export: true },
  { field: "Vigencia", header: "Vigência", Export: true },
  { field: "Tipo_Calculo_Descricao", header: "Tipo de Cálculo", Export: true },
];

export default function GridHeader({ context }) {
  const {
    isLoading,
    paramsOnFilter,
    setParamsOnFilter,
    setTriggerOnFilter,
    setIsOpenModal,
    isOpenModal,
    setIsOpenModalNuevo,
    setInputGlobalSearchValue,
    filteredData,
    userProfile,
  } = React.useContext(context);

  const [preFilter, setPreFilter] = useState([]);
  const [btnActionExport, setBtnActionExport] = useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const [exportProgress, setExportProgress] = useState(0);
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [progressMessage, setProgressMessage] = useState("");
  const isIframePage = useSelector((state) => state.Layout.isIframePage);
  const pageTitle = "Gestão de Fretes";

  const handleExport = async (item) => {
    try {
      setIsExporting(true);
      setShowProgressBar(true);
      setExportProgress(0);

      const label = (item?.label || "").toLowerCase();
      const transactionCode = "DF_LO0020";

      const options = {
        title: pageTitle,
        transactionCode,
        appliedFilters: paramsOnFilter,
        filteredData,
        columns: EXPORT_COLUMNS,
      };

      setExportProgress(30);
      await new Promise((resolve) => setTimeout(resolve, 200));

      if (label.includes("pdf")) {
        setProgressMessage("Gerando PDF...");
        await exportGridToHTML({ ...options, filename: "gestao-fretes.pdf" });
      } else if (label.includes("excel") || label.includes("xlsx")) {
        exportGridToExcel({ ...options, filename: "gestao-fretes.xlsx" });
      } else if (label.includes("csv")) {
        exportGridToCSV({ ...options, filename: "gestao-fretes.csv" });
      } else if (label.includes("html")) {
        setProgressMessage("Gerando HTML...");
        await exportGridToHTML({ ...options, filename: "gestao-fretes.html", convertToPdf: false });
      }

      setExportProgress(100);
      setProgressMessage("Concluído!");
      await new Promise((resolve) => setTimeout(resolve, 200));
    } catch (error) {
      console.error("Erro na exportação:", error);
      setProgressMessage("Erro ao gerar relatório. Verifique o console.");
    } finally {
      setIsExporting(false);
      setBtnActionExport(false);
      setShowProgressBar(false);
      setExportProgress(0);
      setProgressMessage("");
    }
  };

  const onSubmitFilter = (data) => {
    setIsOpenModal(false);
    setParamsOnFilter([{ ...data[0] }]);
    setTriggerOnFilter(true);
  };

  const onClearFilter = () => {
    const hoje = new Date().toLocaleDateString();
    setParamsOnFilter([{
      Filtro_Vigencia_De: { value: hoje, field: "Vigência De" },
      Filtro_Vigencia_Ate: { value: hoje, field: "Vigência Até" },
    }]);
    setPreFilter([{
      Filtro_Vigencia_De: { value: hoje, field: "Vigência De" },
      Filtro_Vigencia_Ate: { value: hoje, field: "Vigência Até" },
    }]);
    setIsOpenModal(false);
    setTriggerOnFilter(true);
  };

  useEffect(() => {
    setTriggerOnFilter(true);
  }, []);

  return (
    <>
      <Row>
        <Col lg={12} className={`mb-3 nav-accordion-custom ${isLoading ? "disabled" : ""}`}>
          <Row className="d-flex align-items-center justify-content-between pb-3">
            <Col id="header-primary-title">
              <HeaderDefaultToPage goBack={isIframePage ? false : true} title={pageTitle} />
            </Col>
            <Col
              id="header-secundary-actions"
              lg={6}
              className="d-flex justify-content-end gap-3 align-items-center"
            >
              <button
                type="button"
                className="btn-criar-rota btn border-color-cinza2 text-primary-dark fw-semibold"
                style={{ whiteSpace: "nowrap", height: 40 }}
                onClick={() => setIsOpenModalNuevo(true)}
              >
                Criar nova rota
              </button>
              <Button
                onClick={() => onSubmitFilter(preFilter)}
                className="bg-transparent border-0 p-0 m-0"
                title="Atualizar"
              >
                <i className="fa-solid font-size-24 fa-rotate-right text-primary-dark"></i>
              </Button>
              <Button
                onClick={() => window.print()}
                className="bg-transparent border-0 p-0 m-0"
                title="Imprimir"
              >
                <i className="fas font-size-24 fa-print text-primary-dark"></i>
              </Button>
              <Dropdown
                isOpen={btnActionExport}
                toggle={() => setBtnActionExport(!btnActionExport)}
                className="dropdown-export-dynamic w-auto"
              >
                <DropdownToggle className="bg-transparent border-0 p-0 m-0" caret disabled={isExporting}>
                  {isExporting ? (
                    <div className="spinner-border spinner-border-sm text-primary" role="status" />
                  ) : (
                    <i className="fas font-size-24 fa-save text-primary-dark"></i>
                  )}
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem onClick={() => handleExport({ label: "pdf" })} className="d-flex align-items-center gap-3">
                    <i className="fa-solid fa-file-pdf"></i>
                    <span>PDF</span>
                  </DropdownItem>
                  <DropdownItem onClick={() => handleExport({ label: "excel" })} className="d-flex align-items-center gap-3">
                    <i className="fa-solid fa-file-xls"></i>
                    <span>XLS</span>
                  </DropdownItem>
                  <DropdownItem onClick={() => handleExport({ label: "csv" })} className="d-flex align-items-center gap-3">
                    <i className="fa-solid fa-file-csv"></i>
                    <span>CSV</span>
                  </DropdownItem>
                  <DropdownItem onClick={() => handleExport({ label: "html" })} className="d-flex align-items-center gap-3">
                    <i className="fa-solid fa-file-code"></i>
                    <span>HTML</span>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>

              <form onSubmit={() => {}}>
                <InputSearch placeholder="Busca rápida" onChange={(e) => setInputGlobalSearchValue(e)} />
              </form>

              <SimpleBarFilterCustom
                isOpen={isOpenModal}
                onClose={setIsOpenModal}
                onSubmit={() => onSubmitFilter(preFilter)}
                onClearFilter={onClearFilter}
              >
                <Row className="m-0 mb-1 form-custom01-filter">
                  <div className="m-0 p-0">
                    <TranspaleStringToComponente
                      elementId="Filtro_Vigencia_De"
                      elementProps={{
                        value: new Date().toLocaleDateString(),
                        type: "Date",
                        title: "Vigência De",
                        id: "Filtro_Vigencia_De",
                      }}
                      preFilter={preFilter}
                      onDefaultValue={(value) => setParamsOnFilter((state) => [{ ...state[0], ...value }])}
                      onPreFilter={(filters) => setPreFilter((state) => [{ ...state[0], ...filters }])}
                    />
                    <TranspaleStringToComponente
                      elementId="Filtro_Vigencia_Ate"
                      elementProps={{
                        value: new Date().toLocaleDateString(),
                        type: "Date",
                        title: "Vigência Até",
                        id: "Filtro_Vigencia_Ate",
                      }}
                      preFilter={preFilter}
                      onDefaultValue={(value) => setParamsOnFilter((state) => [{ ...state[0], ...value }])}
                      onPreFilter={(filters) => setPreFilter((state) => [{ ...state[0], ...filters }])}
                    />
                    <TranspaleStringToComponente
                      elementId="Filtro_ID_Transportadora"
                      elementProps={{
                        value: "",
                        type: "Combobox",
                        title: "Transportadora",
                        id: "Filtro_ID_Transportadora",
                        isDisabled: false,
                        procedure: "FRONT_Componente_Combo_Empresas",
                        procedureParams: [userProfile?.ID_Usuario, "pt-BR", "ORIGEM", "CT"],
                      }}
                      preFilter={preFilter}
                      onPreFilter={(filters) => setPreFilter((state) => [{ ...state[0], ...filters }])}
                    />
                    <TranspaleStringToComponente
                      elementId="Filtro_UF_Origem"
                      elementProps={{
                        value: "",
                        type: "Combobox",
                        title: "UF Origem",
                        id: "Filtro_UF_Origem",
                        isDisabled: false,
                        procedure: "FRONT_Componente_Combo_UF_Origem",
                        procedureParams: [],
                      }}
                      preFilter={preFilter}
                      onPreFilter={(filters) => setPreFilter((state) => [{ ...state[0], ...filters }])}
                    />
                    <TranspaleStringToComponente
                      elementId="Filtro_Municipio_Origem"
                      elementProps={{
                        value: "",
                        type: "Combobox",
                        title: "Município Origem",
                        id: "Filtro_Municipio_Origem",
                        isDisabled: false,
                        procedure: "FRONT_Componente_Combo_Municipios_Origem",
                        procedureParams: ["<#Filtro_UF_Origem#>"],
                        alienated: ["Filtro_UF_Origem"],
                      }}
                      preFilter={preFilter}
                      onPreFilter={(filters) => setPreFilter((state) => [{ ...state[0], ...filters }])}
                    />
                    <TranspaleStringToComponente
                      elementId="Filtro_ID_Fornecedor"
                      elementProps={{
                        value: "",
                        type: "Combobox",
                        title: "Fornecedor",
                        id: "Filtro_ID_Fornecedor",
                        isDisabled: false,
                        procedure: "FRONT_Componente_Combo_Empresas",
                        procedureParams: [userProfile?.ID_Usuario, "pt-BR", "ORIGEM", "NF"],
                      }}
                      preFilter={preFilter}
                      onPreFilter={(filters) => setPreFilter((state) => [{ ...state[0], ...filters }])}
                    />
                    <TranspaleStringToComponente
                      elementId="Filtro_UF_Destino"
                      elementProps={{
                        value: "",
                        type: "Combobox",
                        title: "UF Destino",
                        id: "Filtro_UF_Destino",
                        isDisabled: false,
                        procedure: "FRONT_Componente_Combo_UF_Destino",
                        procedureParams: [],
                      }}
                      preFilter={preFilter}
                      onPreFilter={(filters) => setPreFilter((state) => [{ ...state[0], ...filters }])}
                    />
                    <TranspaleStringToComponente
                      elementId="Filtro_Municipio_Destino"
                      elementProps={{
                        value: "",
                        type: "Combobox",
                        title: "Município Destino",
                        id: "Filtro_Municipio_Destino",
                        isDisabled: false,
                        procedure: "FRONT_Componente_Combo_Municipios_Destino",
                        procedureParams: ["<#Filtro_UF_Destino#>"],
                        alienated: ["Filtro_UF_Destino"],
                      }}
                      preFilter={preFilter}
                      onPreFilter={(filters) => setPreFilter((state) => [{ ...state[0], ...filters }])}
                    />
                    <TranspaleStringToComponente
                      elementId="Filtro_ID_Revenda"
                      elementProps={{
                        value: "",
                        type: "Combobox",
                        title: "Revenda",
                        id: "Filtro_ID_Revenda",
                        isDisabled: false,
                        procedure: "FRONT_Componente_Combo_Empresas",
                        procedureParams: [userProfile?.ID_Usuario, "pt-BR", "DESTINO", "NF"],
                      }}
                      preFilter={preFilter}
                      onPreFilter={(filters) => setPreFilter((state) => [{ ...state[0], ...filters }])}
                    />
                    <TranspaleStringToComponente
                      elementId="Filtro_Status"
                      elementProps={{
                        value: "",
                        type: "Combobox",
                        title: "Status",
                        id: "Filtro_Status",
                        isDisabled: false,
                        dataOptions: [
                          { value: "S", label: "Ativo" },
                          { value: "N", label: "Inativo" },
                        ],
                      }}
                      preFilter={preFilter}
                      onPreFilter={(filters) => setPreFilter((state) => [{ ...state[0], ...filters }])}
                    />
                  </div>
                </Row>
              </SimpleBarFilterCustom>

              <Button
                onClick={() => setIsOpenModal(true)}
                style={{ height: 40, width: 113 }}
                className="button-filter-action font-w-600 bg-primary-dark border-0 text-white px-4 btn-hover-primary"
              >
                Filtros
              </Button>
            </Col>
            <Col md={12}>
              {paramsOnFilter[0] &&
                Object.keys(paramsOnFilter[0]).length !== 0 && (
                  <div className="container-pre-filter-header">
                    <div className="d-flex flex-wrap p-0 gap-2 align-items-center">
                      <button className="btn px-0 border-0 text-black fonto-w-500 font-size-12">
                        Filtros aplicados:
                      </button>
                      {Object.keys(paramsOnFilter[0]).map((key, i) => {
                        return (
                          <PreFilterBadge
                            key={i}
                            index={i}
                            field={paramsOnFilter[0][key].field}
                            value={paramsOnFilter[0][key].label || paramsOnFilter[0][key].value}
                            callback={() => {
                              const obj = { ...paramsOnFilter[0] };
                              const pre = { ...preFilter[0] };
                              delete obj[key];
                              delete pre[key];
                              setPreFilter([pre]);
                              onSubmitFilter([obj]);
                            }}
                          />
                        );
                      })}
                    </div>
                  </div>
                )}
            </Col>
          </Row>

          <ProgressBar
            progress={exportProgress}
            message={progressMessage || "Gerando relatório..."}
            isVisible={showProgressBar}
            showPercentage={true}
            autoHide={true}
            className="export-progress-bar"
          />
        </Col>
      </Row>
    </>
  );
}